
























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbNotice } from '@/http';
import { NumberKeyboard,versionSpecsPanel } from "@/components";
import { Toast } from 'vant';
@Component({ 
    components: {
        NumberKeyboard,versionSpecsPanel
    },
})
export default class xtSetting extends Vue {
   
    public $refs: {
    };

    tabList=[
        {
            label:'云同步设置',
            value:1,
        },
        {
            label:'检查更新',
            value:2,
        },
    ];

    active=1;

    form:any={};
    isEdit=false;
    isEdit2=false;

    isLoading= false;
    isLoading2= false;

    // 版本
    gg_tit = '';

    userInfo = {};

    /**版本相关 */
    versionIno:any={};
    isMust=false;

    

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        if(!this.hasAuth('1501')){
            this.active = 2;
            this.tabList=[
                {
                    label:'检查更新',
                    value:2,
                },
            ];
        }
    }

    async mounted(){
        this.gg_tit = localStorage.getItem('nowVersion');
        this.init();
        window['localVersion'] = (val) => {
            this.localVersion(val)
        }
    }

    localVersion(val){
    // Toast('localVersion,'+val);
    localStorage.setItem('nowVersion',val);
        if(localStorage.getItem('versionIno')){
       
        this.isMust = this.versionIno.minimumVersion==this.versionIno.latestVersion?true:false;
        if(this.versionIno.latestVersion!=val){
            this.$refs['versionSpecsPanel'].showFun();
        }
        
        }
    }
    
    chooseTab(item){
        if(!this.hasAuth('1501')){
            return;
        }
        this.active = item.value;
        this.init();
    }

    async init(){
        if(this.active==1){
            let settingtype = 1;
            let res = await TbSettingsPad.GetTbSettings({
                settingtype:settingtype
            });
            this.form = res;
            console.log('this.form',this.form,this.form.settingContent.isOpenLoginOrOutSync); 
        }else{
            let res = await TbShopAccount.GetVersion({
                versionType:4
            });
            this.versionIno = res;
            // this.gg_tit = 'V'+res.latestVersion;
            // console.log('ress',res);
        }
    }
    finishNum(val,type){
        switch (type) {
            case 1:
                this.form.settingContent.syncMinute=val;
                break;        
            default:
                break;
        }
    }
    changeRadio(val,type){
        switch (type) {
            case 1:
                this.form.settingContent.isOpenLoginOrOutSync=val;
                break;
            case 2:
                this.form.settingContent.isOpenNetworkSync=val;
                break;
            case 3:
                this.form.settingContent.isOpenTimeSync=val;
                break;
            default:
                break;
        }
    }
    editInfo(){
        this.isEdit = !this.isEdit;
    }
    cancelFun(){
        this.isEdit = false;
        this.init();
    }
    cancelFun2(){
        this.isEdit2 = false;
        this.init();
    }
    async saveEdit(){
        if(this.isLoading) return;
        if(!this.form.settingContent.syncMinute){
            Toast('请输入同步时间');
            return;
        }
        if(Number(this.form.settingContent.syncMinute)==0){
            Toast('同步时间不能为0');
            return;
        }
        this.isLoading = true;
        console.log('this,.',this.form);
        try {
            let res= await TbSettingsPad.PutTbSettings({
                id:this.form.id,
                settingContent:JSON.stringify(this.form.settingContent)
            })
            Toast('保存成功');
            this.isEdit = false;
            this.isLoading = false;
            await this.init();
        } catch (error) {
            this.isLoading = false;
        }
    }
    async saveEdit2(){
        if(this.isLoading2) return;

        console.log('this.form.settingContent',this.form.settingContent);
        

        if(!this.form.settingContent.per){
            Toast('请填写相应信息');
            return;
        }
        if(this.form.settingContent.topLimit===null||this.form.settingContent.topLimit===''){
            Toast('请填写相应信息');
            console.log('ssscdsadsad',this.form.settingContent.topLimit);
            
            return;
        }
        
        this.isLoading2 = true;

        try {
            let res= await TbSettingsPad.PutTbSettings({
                id:this.form.id,
                settingContent:JSON.stringify(this.form.settingContent)
            })
            Toast('保存成功');
            this.isEdit2 = false;
            this.isLoading2 = false;
            await this.init();
        } catch (error) {
            this.isLoading2 = false;
        }
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

    checkFun(){
        window.webkit.messageHandlers.getVersion.postMessage('getVersion');
    }

    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/xtSetting.vue